import React, { Component } from "react";
import FadeIn from "react-lazyload-fadein";

export default class Image extends Component {
	
	render () {
		
		
		let src 	= this.props.src;
		let srcset 	= this.props.srcset;
		
		if (this.props.width) {
		
			let width 	= this.props.width;
			let height 	= this.props.height;
						    
		    return (
			    					
				<div className="c-media" style={{paddingTop:((height / width) * 100) + '%'}}>
					<FadeIn>
						{onload => (
							<img
								alt={''} 
								src={src} 
								srcSet={srcset} 
								onLoad={onload}
							/>
						)}
					</FadeIn>
				</div>
			    
			)
		
		} else {
			
			return (
			    					
				<FadeIn>
					{onload => (
						<img
							alt={''} 
							src={src} 
							srcSet={srcset} 
							onLoad={onload}
						/>
					)}
				</FadeIn>
			    
			)
			
		}
			
	}
}
